import {
  SINGLETON_WIDGET_IDS,
  type SingletonEntry,
  type SingletonWidgetId,
  type WidgetEntry,
} from './widgets.types';

interface WidgetDefaults {
  defaultVisible: boolean;
  defaultCollapsed: boolean;
  defaultOrder: number;
}

/**
 * Data-only widget metadata. Lives in its own file so the store and tests can
 * inspect IDs / orders without pulling in component modules (which transitively
 * touch electronApis, the SDK, etc.). Only singletons have defaults; instanced
 * widgets are created on demand with explicit values.
 */
export const WIDGET_DEFAULTS: Record<SingletonWidgetId, WidgetDefaults> = {
  'upcoming-meetings': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 0,
  },
  'todays-routines': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 1,
  },
  'yesterdays-meetings': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 2,
  },
  'pick-up-where-you-left-off': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 3,
  },
  'connect-more-apps': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 4,
  },
  'credit-balance': {
    defaultVisible: true,
    defaultCollapsed: false,
    defaultOrder: 5,
  },
};

const HIDDEN_WIDGET_IDS = new Set<SingletonWidgetId>(['credit-balance']);

export const ACTIVE_WIDGET_IDS: SingletonWidgetId[] =
  SINGLETON_WIDGET_IDS.filter((id) => !HIDDEN_WIDGET_IDS.has(id));

export function defaultSingleton(id: SingletonWidgetId): SingletonEntry {
  const def = WIDGET_DEFAULTS[id];
  return {
    kind: 'singleton',
    type: id,
    visible: def.defaultVisible,
    collapsed: def.defaultCollapsed,
    order: def.defaultOrder,
  };
}

export const DEFAULT_WIDGET_ENTRIES: WidgetEntry[] =
  ACTIVE_WIDGET_IDS.map(defaultSingleton);
